import { isDate, isValid } from 'date-fns';
import { isMoment } from 'moment';

import { isEmpty } from './helpers/is-empty';
import { ValidatorFunction } from '../types/validator-function.type';

export const pattern: ValidatorFunction = (value: any, args: { pattern: string }) => {
  if (isEmpty(value)) {
    return null;
  }

  let tempValue = value.toString();

  if (isDate(value) && isValid(value)) {
    tempValue = value.toISOString();
  } else if (isMoment(value)) {
    tempValue = value.toISOString();
  }

  const tempPattern = args?.pattern?.toString() ?? '';

  if (isEmpty(tempPattern)) {
    return null;
  }

  const regex = new RegExp(tempPattern);

  return regex.test(tempValue) ? null : { pattern: { requiredPattern: args?.pattern, actualValue: tempValue } };
};
